import { GridColDef } from "@mui/x-data-grid"
import "./add.scss"
import React from 'react'
import { ListItem } from "@mui/material"
import { useMutation, useQueryClient } from "@tanstack/react-query"

type Props = {
  slug: string,
  header: string,
  columns: GridColDef[],
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const Add = (props: Props) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => {
      return fetch(`/api/${props.slug}s`, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({

        }),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [`all${props.slug}s`] });
    },
  })

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    //add new Item
    mutation.mutate();
    props.setOpen(false)
  }

  return (
    <div className="add">
      <div className="modal">
        <span className="close" onClick={() => props.setOpen(false)}>
          X
        </span>
        <h1>{props.header}</h1>
        <form onSubmit={handleSubmit}>
          {props.columns
            .filter((item) => item.field !== "_id"
              && item.field !== "img"
              && item.field !== "lastLogin")
            .map((column) => (
              <div className="item">
                <label>{column.headerName}</label>
                <input type={column.type} placeholder={column.field} />
              </div>
            ))}
          <button>Send</button>
        </form>
      </div>
    </div>
  );
};

export default Add